import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../shared/shared.module';
import { JBMDashboardComponent } from './jbm-dashboard.component';
import { JBMDashboardWidgetComponent } from './dashboard-widget/dashboard-widget.component';
import { JBMDashboardWidgetHostComponent } from './dashboard-widget-host/dashboard-widget-host.component';

@NgModule({
  declarations: [
    JBMDashboardComponent,
    JBMDashboardWidgetComponent,
    JBMDashboardWidgetHostComponent
  ],
  imports: [CommonModule, FormsModule, NgbModule, SharedModule],
  exports: [JBMDashboardComponent]
})
export class JBMDashboardModule {}
